import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./CardButton.css');
const arrowIcon = require('assets/blue arrow.svg');

// Props
interface ICardButtonProps {
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    isDisabled?: boolean;
    icon?: string;
    className?: string;
    classNameForIcon?: string;
}

// Component
@observer
export class CardButton extends React.Component<ICardButtonProps, {}> {
    public render() {
        return (
            <button
                className={classNames(
                    s.button,
                    { [s.disabled]: this.props.isDisabled },
                    this.props.className
                )}
                onClick={this.props.onClick}
                disabled={this.props.isDisabled}
            >
                {this.props.children}

                <img
                    className={classNames(s.arrow, this.props.classNameForIcon)}
                    src={this.props.icon || arrowIcon}
                />
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/action/CardButton.tsx